module.exports = __webpack_public_path__ + "img/icon-plus.a4414334.svg";